<script>
  import { onMount } from "svelte";
  import { FileMD5 } from "../../utils/hash";
  import { videoEditStore } from "../../stores/Video/videoEdit";
  import videoUploadStore  from "../../stores/Video/videoUpload";
  import { headerDisplayStore } from "../../stores/General";
  import Form from "../../components/form/Form.svelte";
  import TextArea from "../../components/form/TextArea.svelte";
  import Validators from "../../utils/validators";
  import MultiSelect from "../../components/form/MultiSelect.svelte";
  import {clickOutside} from '../../utils/outsideClick';

  import { getList } from "../../api";
  import { sendPostRequest } from "../../api/crud";

  import Video  from "../../components/Video.svelte"
  import Loader from "../../components/Loader.svelte";
  import Moon from "svelte-loading-spinners/dist/ts/Moon.svelte";
  import CustomIcon from "../../components/CustomIcon.svelte";
  import InputWrapper from "../../components/form/InputWrapper.svelte";
  import PlainInput from "../../components/form/PlainInput.svelte";

  export let onClose = () => {};
  export function reset() {
    form.reset();
  }
  let isEdit = false;
  let isExist = false;
  let hashExist = false;
  let currentVideo;
  let videoFile;
  let videoTitle;
  let baseVideoTitle;
  let videoDescription;
  let videoID;
  let videoObject;
  let form;
  let loading = false;
  let rules = {
    title: {
      validators: [Validators.required, Validators.minLength(2)],
    },
    description: {
      validators: [Validators.required, Validators.minLength(4)],
    },
  };
  let IabCategories = [];
  let source;
  let poster;

  /**
   * chechHash Checks topper hash and returns ok or not
   * 
   * See caller for details
   * @param {{values: string}} data post body
   * @returns Promise<{status: boolean}>
   */
  async function chechHash (data) {
    return await sendPostRequest('/topper/check', data);
  };

  async function onSubmit(e) {
    if (e?.detail?.valid) {
      if (isEdit) {
        loading = true;
        await videoEditStore.Save($videoEditStore);
      } else {
        // TODO save new video
        videoObject = videoFile[0];
        videoObject["title"] = videoTitle;
        videoObject["description"] = videoDescription;
        videoObject["id"] = videoID;
         videoObject["thumbnail"] = poster
        await videoUploadStore.TopperSet(videoFile);
      }
      onClose();
    }
  }
  let isCompleted;

  async function onInput(ev) {
    // await videoUploadStore.SetFiles(ev.target.files);
    loading = true;
    videoFile = ev.target.files;
    if (videoFile && videoFile.length > 0) {
      videoFile = videoFile;
      currentVideo = videoFile
      //check if hash exist
      let hash = await FileMD5(videoFile[0]);
      chechHash({values: hash})
        .then((response) => {
          if (response?.status == true) {
            hashExist = true;
          } else {
            hashExist = false;
            videoID = hash;
          }
        })
        .catch((error) => {
          hashExist = false;
        });
      let reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          source = reader.result + "#t=0.1";
          const video = document.getElementById("videoId");
          const canvas = document.getElementById("canvasId");
          video.addEventListener(
            "loadeddata",
            function () {
              canvas.width = video.videoWidth;
              canvas.height = video.videoHeight;
              const context = canvas.getContext("2d");
              context.drawImage(video, 0, 0, canvas.width, canvas.height);
              poster = canvas.toDataURL();
              loading = false;
            },
            false
          );
        },
        false
      );
      reader.readAsDataURL(videoFile[0]);
    }else{
      loading = false
      videoFile = currentVideo
    }
  }
  function onVideoTitleChange(event) {
    videoTitle = event.detail.target.value;
    $videoEditStore.title = videoTitle;
    console.log('oc', videoTitle)
    if (videoTitle) {
      videoTitle = videoTitle;
    }
  }
  function checkVideoTitle(event) {
    videoTitle = event.detail.target.value;
    let pageSize = 1;
    let page = 1;
    let sortBy = "title";
    let sortOrder = "ASC";
    let filter = { title: videoTitle };

    if (videoTitle) {
      if (videoTitle === baseVideoTitle) {
        isExist = false;
      } else {
        getList('topper' ,pageSize, page, sortBy, sortOrder, filter)
          .then((response) => {
            if (response?.count > 0) {
              isExist = response.data.some((el) => el.title === videoTitle);
            } else {
              isExist = false;
            }
          })
          .catch((error) => {
            isExist = false;
          });
      }
    }
  }
  function onVideoDescriptionChange(event) {
    videoDescription = event.detail.target.value;
    $videoEditStore.description = videoDescription;
    if (videoDescription) {
      videoDescription = videoDescription;
    }
  }
  async function remove(ev) {
    //
  }
  onMount(() => {
    if (!$videoEditStore.iab_categories) $videoEditStore.iab_categories = [];
    if (!$videoEditStore.title) $videoEditStore.title = "";
    isEdit = !!$videoEditStore.title;
    loadIabCategories();
    source = $videoEditStore.asset_url;
    poster = $videoEditStore.thumbnail_url;
  });
  function handleSearchIabCategories(event) {
    if (event.detail) {
      loadIabCategories(event.detail);
    }
  }
  async function loadIabCategories(search = "") {
    let pageSize = 10;
    let page = 1;
    let sortBy = "name";
    let sortOrder = "ASC";
    let filter = {};
    if (search) {
      filter.search = search;
    }
    getList('iab/category', pageSize, page, sortBy, sortOrder, filter)
      .then((response) => {
        IabCategories = response.data;
      })
      .catch((error) => {
        headerDisplayStore.ShowError({
          title: "Server error",
          subtitle: error?.message,
        });
      });
  }
  $: isEmpty = !videoTitle || !videoDescription || !videoFile || !videoFile[0]?.name;
</script>

<div
  class="fixed z-100 inset-0 overflow-y-auto"
  aria-labelledby="modal-title"
  role="dialog"
  aria-modal="true"
>
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" />
  <div
    class="flex items-end justify-center h-screen text-center sm:block sm:p-0"
  >
    <Form {rules} on:submit={onSubmit} bind:this={form}>
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true"
        >&#8203;</span
      >

      <!-- white modal -->
      <div
        class="inline-block bg-white rounded-lg px-6 pt-5 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-full sm:max-w-690 sm:w-full sm:p-6"
        style="margin-top: 10px;margin-bottom: 10px;max-height: calc(100vh - 20px)"
        use:clickOutside on:click_outside={onClose}
      >
        <div class="flex flex-col justify-between" style="max-height: calc(100vh - 50px);">
          <!-- close icon -->
          <div class="block absolute top-8 right-5 z-40 ">
            <div
              type="button"
              class="hover:text-gray-500 border-transparent cursor-pointer"
              on:click={onClose}
            >
              <span class="sr-only">Close</span>
              

              <CustomIcon width="18"
                  height="18" name="close_dialog"/>
            </div>
          </div>

          <!-- modal title -->
          <div class="text-2xl font-bold mb-2 h-15 flex-initial">
            {$videoEditStore.title ? 'Edit Video' : 'Add New Video'}
          </div>

          <!-- form inputs -->
          <div class="overflow-y-scroll flex-1">
            <div>
              <div class="w-full">
                <InputWrapper label="Video Title" required={true}>
                  <!-- TODO: this is now missing the checkVideoTitle validation 
                             which has been built into the input compinent
                             @yehielamar
                  -->
                  <PlainInput
                    name="title"
                    value={$videoEditStore.title}
                    on:change={onVideoTitleChange}
                  />
                </InputWrapper>
              </div>
              <div class="w-full">
                <TextArea
                  label="Video Description"
                  name="description"
                  initialValue={$videoEditStore?.description}
                  on:checkvalid={onVideoDescriptionChange}
                  required={true}
                />
                <div />
                <!-- <div class="mt-1">
                  <Error
                    fieldName="description"
                    errorKey="required"
                    message="Description is required"
                  />
                  <Error fieldName="description" errorKey="minLength" />
                </div> -->
              </div>
              <div class="w-full mt-4">
                <div class="text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                  Categories
                </div>
                <MultiSelect
                  id="iabcats"
                  onChange={(values) => videoEditStore.SetIabCategories(values)}
                  options={IabCategories}
                  values={$videoEditStore.iab_categories}
                  getName={(rec) => rec["iab_category_id"] + ": " + rec["name"]}
                  getKey={(rec) => rec["iab_category_id"]}
                  emptyMessage="No IAB categories assigned to that video."
                  editPlaceholder="Search for a category"
                  on:search={handleSearchIabCategories}
                />
              </div>
              {#if !$videoEditStore.asset_url || $videoEditStore.files?.length == 0}
                <div
                  class=" flex justify-center px-6 mt-5 pt-5 pb-6 border-2 border-custom-orange border-dashed rounded-md bg-custom-light-orange"
                >
                  <span class="text-red-500">*</span>
                  <div class="space-y-1 text-center">
                    <div class="flex text-sm text-gray-600">
                      <label
                        for="file-upload"
                        class="relative cursor-pointer rounded-md font-medium text-yellow-600 hover:text-yellow-500 outline-none"
                      >
                      {#if videoFile && videoFile.length > 0}
                          <span>Upload {videoFile[0]?.name}</span>
                        {:else}
                          <span>Upload a video</span>
                        {/if}
                        <input
                          id="file-upload"
                          on:input={onInput}
                          name="file-upload"
                          type="file"
                          class="sr-only"
                          accept=".mp4,.ogg,.webm"
                          multiple
                        />
                        
                      </label>
                      {#if videoFile && videoFile.length > 0}
                        <p class="pl-1">?</p>
                      {:else}
                        <p class="pl-1">or drag and drop</p>
                      {/if}
                      <span class="ml-1.5">
                        

                        <CustomIcon width="17"
                        height="17" name="image_upload"/>
                      </span>
                    </div>
                  </div>
                </div>
                {#if videoFile && videoFile.length > 0}
                  <Loader {loading} />
                  <div class="w-full flex justify-center">
                    <div
                      class="inline-block cursor-pointer align-bottom bg-white p-2 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-full max-w-2xl sm:w-full"
                    >
                      {#if source && poster}
                        <Video {source} {poster} borderRadius="0px" />
                        {#if hashExist}
                          <div class="w-full flex justify-center">
                            <p
                              class="text-red-500 text-xs justify-center items-center"
                            >
                              Video already exist
                            </p>
                          </div>
                        {/if}
                      {/if}
                      <div style="display:none;">
                        <video
                          width="100%"
                          id="videoId"
                          controls
                          preload="metadata"
                          src={source}
                        >
                          <track kind="captions" />
                        </video>
                        <canvas id="canvasId" />
                      </div>
                    </div>
                  </div>
                {/if}
                <!-- <p class="text-2xs mt-2 text-gray-400">You can upload not more than 25MB</p> -->
              {:else}
                <div
                  class=" flex justify-center px-6 pt-5 mt-6 pb-6 border-2 border-custom-upload-gray rounded-md bg-custom-light-orange"
                >
                  <div
                    class="flex space-y-1 text-center grow justify-center"
                  >
                    
                    <CustomIcon width="28"
                    height="28" name="uploaded" />
                    <div class="ml-5 flex text-sm text-gray-600">
                      <label
                        for="file-upload"
                        class="relative rounded-md font-medium outline-none"
                      >
                        <span>{$videoEditStore?.title}</span>
                      </label>
                    </div>
                  </div>
                  <div class="flex">
                    <a
                      on:click|preventDefault={() => {
                        remove();
                      }}
                      class="rounded inline-block border border-transparent focus:outline-none focus:border-gray-800 focus:shadow-outline-gray"
                      href="/"
                    >
                      

                      <CustomIcon width="20"
                      height="20" name="remove"/>
                    </a>
                  </div>
                </div>
                <div class="w-full flex justify-center">
                  <div
                    class="inline-block cursor-pointer align-bottom bg-white p-2 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-full max-w-2xl sm:w-full"
                  >
                    <Video {source} {poster} />
                  </div>
                </div>
              {/if}
            </div>
          </div>
          <!-- submit button -->
          <div class="pt-2 flex justify-center w-full bg-white h-14 flex-initial">
            <!-- if the video is uploading, this will be the button state -->
            <button
            type="submit"
            on:click|once={onSubmit}
            disabled={$videoEditStore.asset_url ? loading : isEmpty || !source || !poster || isExist || hashExist} 
            class="w-80 h-12 relative inline-flex items-center justify-center px-1 py-2 rounded-md border shadow-nv border-custom-orange bg-custom-orange text-sm font-medium text-white hover:bg-custom-orange focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
          >
        <span class={isEmpty || !source || !poster || isExist || hashExist ? "text-zinc-600 disabled":"text-white text-base"}>{loading && !$videoEditStore.asset_url ? 'Loading video...':loading && $videoEditStore.asset_url ? 'Updating..': 'Save'}</span>
            <!-- if the video is loading or uploading, this will be the loading state -->
        {#if loading || $videoUploadStore.files.length > 0 && !$videoUploadStore.isDone}
        <Moon size={2} color="#FFF" unit="rem" duration="1s" />
        {/if}
          </button>
          </div>
        </div>
      </div>
    </Form>
  </div>
</div>
